// TablePaginationButtons.js
import React from "react";
import { Button } from "reactstrap";

const TablePaginationButtons = ({
    currentPage,
    totalItems,
    pageSize,
    onPageChange,
    className = "",
}) => {
    const isPrevDisabled = currentPage === 1;
    const isNextDisabled = currentPage * pageSize >= totalItems;

    return (
        <div className={`mt-2 d-flex gap-2 ${className}`}>
            <Button
                size="sm"
                disabled={isPrevDisabled}
                onClick={() => !isPrevDisabled && onPageChange(currentPage - 1)}
            >
                Prev
            </Button>
            <Button
                size="sm"
                disabled={isNextDisabled}
                onClick={() => !isNextDisabled && onPageChange(currentPage + 1)}
            >
                Next
            </Button>
        </div>
    );
};

export default TablePaginationButtons;